import { render, staticRenderFns } from "./compass-planet.svg.vue?vue&type=template&id=0ec929e3&"
import script from "./compass-planet.svg.vue?vue&type=script&lang=js&"
export * from "./compass-planet.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports